import React, { useState } from 'react';
import { TextField, Button, Typography, MenuItem } from '@mui/material';
import { useProblem } from '../../hooks/useProblem';
import { StyledFormContainer } from './ProblemStyles';
import { serverTimestamp } from 'firebase/firestore'; // Import serverTimestamp directly from Firestore
import { Problem } from '../../models/Problem';
import { useSelector } from 'react-redux'; // <-- Import useSelector
import { RootState } from '../../redux/store'; // <-- Import RootState for types

const ProblemCreate: React.FC = () => {
  const { createProblem } = useProblem();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [status, setStatus] = useState<Problem['status']>('open');

  // Get the current user from Redux
  const { user } = useSelector((state: RootState) => state.user);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (user && user.id) {
      // Pass the user ID from Redux
      createProblem({
        title,
        description,
        status: 'open',
        userId: user.id, // <-- Use the user ID from Redux
        createdAt: serverTimestamp(), // <-- Use serverTimestamp from Firebase
        updatedAt: serverTimestamp(), // <-- Use serverTimestamp from Firebase
      });
      setTitle('');
      setDescription('');
      setStatus('open');
    } else {
      console.error('User ID not found');
    }
  };

  return (
    <StyledFormContainer>
      <Typography variant="h6" component="h2" gutterBottom>
        Create New Problem
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Title"
          value={title}
          onChange={e => setTitle(e.target.value)}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Description"
          value={description}
          onChange={e => setDescription(e.target.value)}
          fullWidth
          margin="normal"
          multiline
          rows={8}
          required
        />
        <Button type="submit" variant="contained" color="primary">
          Create Problem
        </Button>
      </form>
    </StyledFormContainer>
  );
};

export default ProblemCreate;
